import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@repo/ui/card'
import { useT } from '@repo/ui/hooks'

import RawMetricForm from './RawMetricForm'
import { FormType } from './types'

export default function MetricForm({ form }: { form: FormType }) {
  const { t } = useT({ keyPrefix: 'admin.insights.form.metric' })

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('title')}</CardTitle>
        <CardDescription>{t('description')}</CardDescription>
      </CardHeader>
      <CardContent>
        <RawMetricForm form={form} />
      </CardContent>
    </Card>
  )
}
